import { supabase } from "@/integrations/supabase/client";

export interface ProductInfo {
  product_name: string;
  product_sku: string;
  product_bc: string;
  eenheid: string;
}

export const lookupProductsBySKUs = async (skus: string[]): Promise<ProductInfo[]> => {
  if (skus.length === 0) return [];
  
  const { data, error } = await supabase
    .from('voorraad_live2')
    .select('product_naam, product_id, bc, eenheid')
    .in('product_id', skus);
  
  if (error) {
    console.error('Error looking up products:', error);
    return [];
  }
  
  return (data || []).map(item => ({
    product_name: item.product_naam || '',
    product_sku: item.product_id,
    product_bc: item.bc || '',
    eenheid: item.eenheid || ''
  }));
};
